(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { createSelector } from "reselect";
import { moduleName } from "./types";

const moduleSelector = state => state[moduleName];

const propsSelector = (_, props) => props;

export const isSearchReadySelector = createSelector(moduleSelector, state => !state.countries.isLoading && !!state.countries.data.length);
export const countryCodeSelector = createSelector(moduleSelector, state => state.countryCode);
export const countriesSelector = createSelector(moduleSelector, state => state.countries.data);
export const searchStringSelector = createSelector(moduleSelector, state => state.searchString);
export const isHistoryLoadingSelector = createSelector(moduleSelector, state => state.history.isLoading);
export const historySelector = createSelector(moduleSelector, state => state.history.data);
export const isHsCodesLoadingSelector = createSelector(moduleSelector, state => state.hsCodes.isLoading);
export const hsCodesHasErrorSelector = createSelector(moduleSelector, state => state.hsCodes.hasError);
export const hsCodesSelector = createSelector(moduleSelector, state => state.hsCodes.data);
export const detailsSelector = createSelector(moduleSelector, state => state.details.data);
export const explanatoryNotesSelector = createSelector(moduleSelector, state => state.explanatoryNotes.data);
export const explanatoryNotesPendingSelector = createSelector(moduleSelector, state => state.explanatoryNotes.isLoading);
export const explanatoryNotesHasErrorSelector = createSelector(moduleSelector, state => state.explanatoryNotes.hasError);
export const hsCodeDetailsSelector = createSelector([detailsSelector, propsSelector], (details, props) => details["".concat(props.hsCode, "_").concat(props.countryCode)]);
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(moduleSelector, "moduleSelector", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/selectors.js");
  reactHotLoader.register(propsSelector, "propsSelector", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/selectors.js");
  reactHotLoader.register(isSearchReadySelector, "isSearchReadySelector", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/selectors.js");
  reactHotLoader.register(countryCodeSelector, "countryCodeSelector", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/selectors.js");
  reactHotLoader.register(countriesSelector, "countriesSelector", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/selectors.js");
  reactHotLoader.register(searchStringSelector, "searchStringSelector", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/selectors.js");
  reactHotLoader.register(isHistoryLoadingSelector, "isHistoryLoadingSelector", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/selectors.js");
  reactHotLoader.register(historySelector, "historySelector", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/selectors.js");
  reactHotLoader.register(isHsCodesLoadingSelector, "isHsCodesLoadingSelector", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/selectors.js");
  reactHotLoader.register(hsCodesHasErrorSelector, "hsCodesHasErrorSelector", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/selectors.js");
  reactHotLoader.register(hsCodesSelector, "hsCodesSelector", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/selectors.js");
  reactHotLoader.register(detailsSelector, "detailsSelector", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/selectors.js");
  reactHotLoader.register(explanatoryNotesSelector, "explanatoryNotesSelector", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/selectors.js");
  reactHotLoader.register(explanatoryNotesPendingSelector, "explanatoryNotesPendingSelector", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/selectors.js");
  reactHotLoader.register(explanatoryNotesHasErrorSelector, "explanatoryNotesHasErrorSelector", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/selectors.js");
  reactHotLoader.register(hsCodeDetailsSelector, "hsCodeDetailsSelector", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/state/selectors.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();